module.exports = __webpack_public_path__ + "img/ios.c7292647.png";